import { render } from "./members.vue?vue&type=template&id=06bec856"
import script from "./members.vue?vue&type=script&lang=js"
export * from "./members.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brunocarvalho/Projetos/admin-colegio-encanto-juvenil/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__